import styled from "styled-components";
import * as colors from "src/styles/constants/colors";
import * as spacing from "src/styles/constants/spacing";
import * as radius from "src/styles/constants/radius";
import { colors as oldColors } from "src/styles/constants";
import { fontSize } from "src/styles/constants/size";

export const RecentChats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
`;

export const ViewAuditTrail = styled.div<{
  expanded: boolean;
  sticky: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 18px;
  cursor: pointer;
  ${(props) =>
    props.expanded &&
    `
    ${props.sticky && `position: sticky;`}
    top: 0;
    z-index: 10;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); 
    background-color: ${colors.brightLight};
  `}
  :hover {
    background-color: #e6f0ff;
    span {
      font-weight: bold;
    }
  }
`;

export const ViewUpdatesButton = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 0 12px;
`;

export const ViewUpdatesLabel = styled.span`
  font-size: 12px;
  color: ${colors.grey39};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ViewUpdatesHr = styled.hr`
  width: 100%;
  border: 1px solid #1581ba;
`;

export const DateBreak = styled.div<{ belowViewAuditTrail?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  position: sticky;
  top: ${(props) => (props.belowViewAuditTrail ? "44px" : "6px")};
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  z-index: 999;
  width: 92px;
  border: 1px solid #d0d5dd;
  background-color: #f3f8fb;
  color: #667085;
`;
